export const geoJsonToLatLng = (coordinates: [number, number]): { lat: number; lng: number } => {
  if (!coordinates || coordinates.length < 2) {
    return { lat: 0, lng: 0 }
  }
  return { lat: coordinates[1], lng: coordinates[0] }
}

export const computeBearing = (from: { lat: number; lng: number }, to: { lat: number; lng: number }): number => {
  if (from.lat === to.lat && from.lng === to.lng) {
    return 0
  }
  const toRad = (d: number) => d * Math.PI / 180;
  const φ1 = toRad(from.lat), φ2 = toRad(to.lat), Δλ = toRad(to.lng - from.lng);
  const y = Math.sin(Δλ) * Math.cos(φ2);
  const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
  return (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
}

export const isValidTrackRange = (fromSec: number, toSec: number): { valid: boolean; reason?: "order" | "tooLarge" } => {
  const ONE_DAY_SECONDS = 24 * 60 * 60;
  if (toSec < fromSec) {
    return { valid: false, reason: "order" }
  }
  if (toSec - fromSec > ONE_DAY_SECONDS) {
    return { valid: false, reason: "tooLarge" }
  }
  return { valid: true }
}
